import * as React from 'react';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { change, Field, getFormValues, initialize, InjectedFormProps, reduxForm } from 'redux-form';
import { Button, Row, Col } from 'reactstrap';
import { Dispatch } from 'redux';
import { AxiosError } from 'axios';
// import "../PortalPage/portalPage.scss"
import validate from './CreateCaseValidate';
import FutureDatePicker from '../../commonfields/FutureDatePicker';
import { transformDateWithDash, transformUTCDateWithoutTime } from '../../utils/dateUtil';
import SelectField from '../../commonfields/SelectField';
import TextField from '../../commonfields/TextField';
import normalizeTextarea from '../../utils/NormalizeTextarea';
import MultipleSelectField from '../../commonfields/MultipleSelectField';
import { CaseNotificationsEnum, ICaseTaskNotificationModel } from '../../models/Cases/CaseDetailsModel';
import MultipleFileDropZoneField from '../../commonfields/MultipleFileUpload';
import Service from '../../services';
import { toast } from 'react-toastify';
import SelectButtonField from '../../commonfields/SelectButtonField';
import SelectButtonField2 from '../../commonfields/SelectButtonField2';
import { BankUserContext } from '../../bankUserContext';
import FinSpinner from '../../commonfields/FinSpinner';



export interface CreateCaseModal {
  title: string;
  assignTo: string;
  caseType: string;
  lor?: string;
  notes: string;
  dueDate: string;
  dueDateNotificationId: string[];
  completionDateNotificationId: string[];
  status?: string;
  edit?: boolean;
  deletedDocumentsList?: string[]
}


const CreateCaseFrom: React.FC<any &
  InjectedFormProps<Record<string, unknown>, any>> = (props: any) => {
    const { invalid, edit, deletedDocuments, setDeletedDocuments } = props;
    const context = React.useContext(BankUserContext);

    const [loader, setLoader] = useState(false)
    const [selectLor, setSelectLor] = useState(false);
    const [allManualTodoUsers, setAllManualTodoUsers] = useState([]);
    const service = new Service();

    const appType = [
      {
        value: "General",
        text: "General",
      },
      {
        value: "LOR",
        text: "Company",
      },
    ];

    const deleteDocumentChanges = (item: any, index: number) => {
      if (item?.caseDocMappingId && item?.documentUrl) {
        setDeletedDocuments && setDeletedDocuments([
          ...(props?.caseDetails ? deletedDocuments : []),
          {
            caseDocMappingId: item?.caseDocMappingId,
            documentUrl: item?.documentUrl,
          }
        ])
      }
    }

    // need to change for UUID 
    const getAllManualTodoUsers = () => {
      service.getAllManualTodoUsers(context?.bankuserDetails?.organization?.orgId, 4).then((response: any) => {
        const data = response.data.map((element: any) => {
          return { text: `${element.firstName + " " + element.lastName}`, value: element.userId }
        })
        setAllManualTodoUsers(data)
      })
    }

    React.useEffect(() => {
      getAllManualTodoUsers();
      // eslint-disable-next-line react-hooks/exhaustive-deps
      props?.caseDetails?.caseType === "LOR" ? setSelectLor(true) : setSelectLor(false)
    }, [])



    const onChangeType = (e: any) => {
      props.change("selectLOR", "")
      if (e == "LOR") {
        setSelectLor(true)
      } else {
        setSelectLor(false)
      }
    }
    const CreateCaseHandler = (value: string) => {
      setLoader(true);
      const postData: CreateCaseModal = {
        title: props?.formValues?.caseTitle,
        assignTo: props?.formValues?.assignTo,
        caseType: props?.formValues?.caseType,
        lor: props?.formValues?.caseType === "LOR" ? props?.formValues?.lor : null,
        notes: props?.formValues?.notes,
        dueDate: transformDateWithDash(props?.formValues?.dueDate) || '',
        dueDateNotificationId: props?.formValues?.reachingDueDateNotification?.map((each: any) => each.value) || [],
        completionDateNotificationId: props?.formValues?.completionNotification?.map((each: any) => each.value) || [],
        deletedDocumentsList: deletedDocuments || [],
        ...(props?.caseDetails?.caseId ? { caseId: props?.caseDetails?.caseId } : {}),
      }
      const documents = props?.formValues?.documents?.filter((each: any) => !each?.caseDocMappingId)
      if (value == "draft") {
        postData.status = "DRAFT"
      }
      console.log("payload", postData)
      service.createFinCase(postData, documents).then((response: any) => {
        if (response.status == 201) {
          toast.success(props?.caseDetails?.caseId ? "Case Updated Successfully" : "Case Created Successfully")
          // setTimeout(() => {
          props?.toogleHandle && props.toogleHandle();
          // }, 1500);
          setDeletedDocuments([]);
          setLoader(false);
        }
      }).catch((err: any) => {
        toast?.error(err?.response?.data?.errorMessage)
        setLoader(false);
      })
    }



    const displayTodoTypeSelection = () => {
      return (
        <Row className="caseTypeRow">
          <Col md="4">
            <Field
              component={SelectButtonField2}
              isRequired={true}
              name={"caseType"}
              label={"Case Type"}
              HelpText={""}
              values={appType}
              onChange={(e: any) => {
                onChangeType(e);
              }}
            />
          </Col>
          <Col md="6" className="lor">
            {props?.formValues?.caseType && props?.formValues?.caseType === "LOR" ? <Field
              isRequired={true}
              component={SelectField}
              name={"lor"}
              label={"Company:"}
              HelpText={"Company"}
              values={props?.allLORClients || []}
              className={'lor'}
              optionLength={38}
            /> : null}
          </Col>
        </Row>
      )
    }

    return (
      <div className="createCaseForm">
        {/* <ToastContainer /> */}
        {loader ? <FinSpinner /> : null}
        <form className="form-group">
          {/* <h4 className='createTodoFormTitle mb-3'>{ edit ? "Edit Case"  : "Create New Case"}</h4> */}
          <Row>
            <Col>
              <div className='leftInput'>
                <Field
                  component={TextField}
                  isRequired={true}
                  type="text"
                  name={'caseTitle'}
                  label="Case Title"
                  HelpText={"todoDescription"}
                  disabled={props?.disableFields}
                  normalize={normalizeTextarea}
                />
              </div>
            </Col>
            <Col>
              <div className='rightInput'>
                <Field
                  component={SelectField}
                  // isRequired={true}
                  name={"assignTo"}
                  label={"Assign To"}
                  HelpText={"Assign To"}
                  values={allManualTodoUsers || []}
                  disabled={props?.disableFields}
                />
              </div>
            </Col>
          </Row>

          {displayTodoTypeSelection()}
          <Field
            component={TextField}
            isRequired={true}
            name={"notes"}
            label={`Notes and Guidance (${props?.formValues?.notes?.length || 0}/1000)`}
            type="textarea"
            maxlength={1000}
            disabled={props?.disableFields}
            normalize={normalizeTextarea}
          />
          <Field
            component={MultipleFileDropZoneField}
            name={"documents"}
            label={"Documents"}
            type="file"
            acceptedFormats="image/jpeg, image/png, image/gif, image/bmp, .pdf, .doc, .docx, .xls,.xlsx, .csv"
            allowMultiple={true}
            maxSize={5000000}
            disabled={props?.disableFields}
            preserveFiles={true}
            preserveBasedOn={props?.caseDetails ? 'caseDocMappingId' : ''}
            getDeletedItem={deleteDocumentChanges}
          />
          <Col md="12" className="dueDateCol">
            <label className="form-label">
              Due Date {<span className="input-required">*</span>}
            </label>
            <Field
              disabled={props?.disableFields}
              name={"dueDate"}
              isRequired={true}
              component={FutureDatePicker}
              // valuedata={null}
              minDate={new Date()}
              showYearDropdown
              autoComplete="off"
              checkTouched={true}
              isValidation={false}
            />
          </Col>
          <Row>
            <Col>
              <div className='leftInput'>
                <Field
                  component={MultipleSelectField}
                  // isRequired={true}
                  type="text"
                  name={'reachingDueDateNotification'}
                  label="Reaching Due Date Notification"
                  HelpText={"reachingDueDateNotification"}
                  flip={true}
                  values={allManualTodoUsers}
                  disabled={props?.disableFields}
                />
              </div>
            </Col>
            <Col>
              <div className='rightInput'>
                <Field
                  component={MultipleSelectField}
                  // isRequired={true}
                  name={"completionNotification"}
                  label={"Completion Notification"}
                  HelpText={"completionNotification"}
                  values={allManualTodoUsers}
                  disabled={props?.disableFields}
                  flip={true}
                />
              </div>
            </Col>
          </Row>
          <Button
            disabled={invalid || props?.disableFields || loader} className="createButton"
            onClick={() => CreateCaseHandler('create')}
          >
            {edit ? "Update" : "Create"}
          </Button><br />
          {edit ? <></> : <div className='saveAsDraftDiv'>
            <span className='saveAsDraft' onClick={() => CreateCaseHandler("draft")}>Save as Draft</span>
          </div>}
        </form>
      </div>
    );
  }

export default connect((state: Record<string, unknown>, props: any) => {
  return {
    initialValues: {
      caseTitle: props?.caseDetails?.title,
      caseType: props?.caseDetails?.caseType,
      lor: props?.caseDetails?.lor,
      assignTo: props?.caseDetails?.assignTo,
      dueDate: transformUTCDateWithoutTime(props?.caseDetails?.dueDate),
      reachingDueDateNotification:
        props?.caseDetails?.caseNotifications?.filter(
          (each: ICaseTaskNotificationModel) => each?.type === CaseNotificationsEnum.DUE)
          .map((item: ICaseTaskNotificationModel) => {
            return { text: item?.userName, value: item?.userId };
          }),
      completionNotification:
        props?.caseDetails?.caseNotifications?.filter(
          (each: ICaseTaskNotificationModel) => each?.type === CaseNotificationsEnum.COMPLETION)
          .map((item: ICaseTaskNotificationModel) => {
            return { text: item?.userName, value: item?.userId };
          }),
      notes: props?.caseDetails?.notes,
      documents: props?.caseDetails?.caseDocuments,
    },
    formValues: getFormValues("CreateCaseFrom")(state),
  };
})(
  reduxForm<Record<string, unknown>, any>({
    form: "CreateCaseFrom",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    validate,
  })(CreateCaseFrom)
);



